import { render, staticRenderFns } from "./BestDuration.vue?vue&type=template&id=8d4125ba&scoped=true"
import script from "./BestDuration.vue?vue&type=script&lang=js"
export * from "./BestDuration.vue?vue&type=script&lang=js"
import style0 from "./BestDuration.vue?vue&type=style&index=0&id=8d4125ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d4125ba",
  null
  
)

export default component.exports